import { MRT_Row } from 'material-react-table'

import { Button, DialogWrapper, MessageModal } from '@/components'
import { useAppContext } from '@/hooks'
import { DdlModal } from '@/pages/User/pages/Home/components/Deployments/components/DdlModal'
import { ExtEnvironmentDeploymentDto } from '@/pages/User/pages/Home/components/Deployments/types'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'

interface NewDeploymentsActions {
	row: MRT_Row<ExtEnvironmentDeploymentDto>
}

export const NewDeploymentsActions = ({ row }: NewDeploymentsActions) => {
	const { t } = useAppContext()

	const {
		state: { node, editMode },
	} = useDetailTabContext()

	return (
		<div className="flex items-center gap-4 ml-4">
			<DialogWrapper
				dialog={(opened, onClose) =>
					opened && (
						<>
							<DdlModal
								preview
								environment={row.original}
								node={node}
								onClose={onClose}
							/>
						</>
					)
				}
			>
				{(onClick) => (
					<Button size="sm" onClick={onClick}>
						{t('PREVIEW_DLL')}
					</Button>
				)}
			</DialogWrapper>
			<DialogWrapper
				dialog={(opened, onClose) =>
					opened && (
						<>
							<DdlModal
								environment={row.original}
								node={node}
								onClose={onClose}
							/>
							{editMode && (
								<MessageModal
									title={t('DEPLOYED_UNPUSHED_CHANGES_WARN_TITLE')}
									type="warn"
									message={t('DEPLOYED_UNPUSHED_CHANGES_WARN')}
								/>
							)}
						</>
					)
				}
			>
				{(onClick) => (
					<Button size="sm" onClick={onClick}>
						{t('CREATE_DDL')}
					</Button>
				)}
			</DialogWrapper>
		</div>
	)
}
